export default __webpack_public_path__ + "static/media/hip_hop_dancing3.d09a9de7.gif";